import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useAuth } from "@/providers/auth-provider";
import {
  getFriends,
  sendFriendRequest,
  respondFriendRequest,
  removeFriend,
  sendKeyGift,
  claimKeyGift,
  getLfgLobbies,
  getFeed,
} from "@/services/social/social";
import { queryKeys } from "./query-keys";

export const useFriends = () => {
  const { state } = useAuth();
  return useQuery({
    queryKey: queryKeys.friends,
    queryFn: async () => {
      const res = await getFriends();
      if (!res.ok) throw new Error(res.message);
      return res.data;
    },
    enabled: state.status === "authenticated",
  });
};

export const useSendFriendRequest = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: sendFriendRequest,
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.friends }),
  });
};

export const useRespondFriendRequest = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: respondFriendRequest,
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.friends }),
  });
};

export const useRemoveFriend = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: removeFriend,
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.friends }),
  });
};

export const useSendKeyGift = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: sendKeyGift,
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.friends }),
  });
};

export const useClaimKeyGift = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: claimKeyGift,
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.friends }),
  });
};

export const useLfgLobbies = (enabled: boolean) => {
  const { state } = useAuth();
  return useQuery({
    queryKey: queryKeys.lfgLobbies,
    queryFn: async () => {
      const res = await getLfgLobbies();
      if (!res.ok) throw new Error(res.message);
      return res.data;
    },
    enabled: state.status === "authenticated" && enabled,
    refetchInterval: 8000,
  });
};

export const useFeed = () => {
  const { state } = useAuth();
  return useQuery({
    queryKey: queryKeys.feed,
    queryFn: async () => {
      const res = await getFeed();
      if (!res.ok) throw new Error(res.message);
      return res.data;
    },
    enabled: state.status === "authenticated",
    refetchInterval: 30000,
  });
};
